import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AvatarContainer } from './components/AvatarContainer';
import { MenuAvatarDesktop } from './components/MenuAvatarDesktop';
import { MenuAvatarMobile } from './components/MenuAvatarMobile';
import './style.scss';
import {
  hideMenuAvatar,
  hideMenuAvatarMobile,
} from './actions/menuAvatar.actions';

export const MenuAvatar = ({ showDropDownMenu, isDropDownActive }) => {
  const user = useSelector(state => state.user);
  const showMenu = useSelector(state => state.menuAvatar.showMenu);
  const showMenuMobile = useSelector(state => state.menuAvatar.showMenuMobile);
  const { isMobile } = useVerifyIsMobile(918);
  const dispatch = useDispatch();

  useEffect(
    () => {
      if (isMobile) {
        if (!showMenu) dispatch(hideMenuAvatarMobile());
      }
    },
    [isMobile, showMenu],
  );

  useEffect(
    () => {
      if (isMobile) {
        if (showMenuMobile && isDropDownActive) {
          showDropDownMenu(false);
        }
      }
    },
    [isMobile, showMenuMobile, isDropDownActive],
  );

  return (
    <div className="cv-menu-avatar">
      <AvatarContainer isMobil={isMobile} />
      {isMobile && showMenuMobile && (
        <MenuAvatarMobile onClose={() => dispatch(hideMenuAvatarMobile())} />
      )}
      {!isMobile && user.user_id && showMenu && (
        <MenuAvatarDesktop onClose={() => dispatch(hideMenuAvatar())} />
      )}
    </div>
  );
};
